(() => {
  const getRoot = () => {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root.length ? root : '/';
  };

  const addHomeLinks = () => {
    const root = getRoot();
    const menus = document.querySelectorAll('.mff-header__menu, .mff-mobile-menu nav ul');

    menus.forEach((menu) => {
      const links = Array.from(menu.children).map((item) => item.querySelector('a')).filter(Boolean);
      const hasHome = links.some((link) => {
        try {
          const pathname = new URL(link.href, window.location.origin).pathname.replace(/\/+$/, '') || '/';
          const rootPath = new URL(root, window.location.origin).pathname.replace(/\/+$/, '') || '/';
          return pathname === rootPath || link.textContent.trim().toLowerCase() === 'startseite';
        } catch (error) {
          return false;
        }
      });

      if (hasHome) return;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = root;

      if (menu.closest('.mff-mobile-menu')) {
        link.innerHTML = '<span class="mff-mobile-menu__link-title">Startseite</span><span class="mff-mobile-menu__link-arrow" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M7 17 17 7M9 7h8v8"/></svg></span>';
      } else {
        link.textContent = 'Startseite';
      }

      const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
      const rootPath = new URL(root, window.location.origin).pathname.replace(/\/+$/, '') || '/';
      if (currentPath === rootPath) link.setAttribute('aria-current', 'page');

      item.appendChild(link);
      menu.prepend(item);
    });
  };

  const optimizeIdeaCard = () => {
    const card = document.querySelector('.mff-home-action[href="#MFFStory"]');
    if (!card) return;

    const root = getRoot();
    card.href = `${root.replace(/\/?$/, '/')}pages/unsere-idee`;
    card.setAttribute('aria-label', 'Die Idee hinter MFF entdecken');

    const cta = card.querySelector('strong');
    if (cta) cta.innerHTML = 'Idee entdecken <span aria-hidden="true">↗</span>';
  };

  const initialize = () => {
    addHomeLinks();
    optimizeIdeaCard();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();